// import { createApp } from "vue";
// import ElementPlus from "element-plus";
// import "element-plus/dist/index.css";
// import App from "./App.vue";
// import "./css/main.css";
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import 'element-plus/theme-chalk/dark/css-vars.css'
// // import axios from "axios";


// // axios({
// //   baseURL: 'http://localhost:8088/v1/',
// //   changeOrigin: true,
// //   timeout: 5000, // 请求超时时间
// //   withCredentials: true
// // })

// const app = createApp(App);
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component);
// }
// app.use(ElementPlus);
// // axios.defaults.baseURL = "/api";
// // axios.defaults.headers.post["Content-Type"] = "application/json";

// // app.use(service);
// app.mount("#app");
// import { createApp } from "vue";
// import ElementPlus from "element-plus";
// import "element-plus/dist/index.css";
// import App from "./App.vue";
// import "./css/main.css";
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import 'element-plus/theme-chalk/dark/css-vars.css'
// // import axios from "axios";


// // axios({
// //   baseURL: 'http://localhost:8088/v1/',
// //   changeOrigin: true,
// //   timeout: 5000, // 请求超时时间
// //   withCredentials: true
// // })

// const app = createApp(App);
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component);
// }
// app.use(ElementPlus);
// // axios.defaults.baseURL = "/api";
// // axios.defaults.headers.post["Content-Type"] = "application/json";

// // app.use(service);
// app.mount("#app");

import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import App from "./App.vue";
import "./css/main.css";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/theme-chalk/dark/css-vars.css'
import axios from "axios";
import VueHead from 'vue-head'
import Cookies from 'js-cookie'
// import VueRouter from 'vue-router';


// import router from './router.js'; // 引入路由配置文件  
// import Vue from 'vue';  
// import VueRouter from 'vue-router';
import Casdoor from 'casdoor-vue-sdk'

const config = {
  serverUrl: "https://account.gusui.site",
  clientId: "daabea6f1613a8ec2528",
  organizationName: "gusui",
  appName: "gusui",
  redirectPath: "/",
};

// const app = createApp(App)


axios.defaults.withCredentials = false;
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(ElementPlus);
app.use(Cookies);
// app.use(router);
app.use(VueHead);
app.use(Casdoor, config);
app.mount("#app");